module.exports = __webpack_public_path__ + "static/media/roundaboutCCW315.b2fe5661.svg";